<div class="d-flex listing-icons align-items-center">
  <div class="tile-list-view mr-2 cursor" *ngIf="toggle">
    <img src="../../../../assets/images/listView.svg" title="List-Toggle" (click)="onClick()" class="h-30"
      alt="tile-list-view">
  </div>
  <div class="tile-list-view cursor" *ngIf="!toggle">
    <img src="../../../../assets/images/list-view.svg" title="Tile-Toggle" (click)="onClick()" class="h-30"
      alt="tile-list-view">
  </div>
</div>